import './App.css';
import MainContainer from './components/mainContainer/MainContainer';
import React from 'react';

const App = () => {
  return (
    <div data-testid="App">
        <MainContainer />
    </div>
  );
};
export default App;
